import React from 'react';

export default function Loading() {
	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
			<div className="spinner" style={{ width: 48, height: 48, borderWidth: 4 }} />
			<div style={{ marginTop: 16 }}>Loading...</div>
		</div>
	);
}
